import { render, staticRenderFns } from "./search-case.vue?vue&type=template&id=f5aaae9a&"
import script from "./search-case.vue?vue&type=script&lang=js&"
export * from "./search-case.vue?vue&type=script&lang=js&"
import style0 from "./search-case.vue?vue&type=style&index=0&id=f5aaae9a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports